import React from "react";

function Maintanance() {

  const goBack = () => {
    window.history.back();
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🚧</div>
         <p style={styles.text}>
          selexsuite.com
        </p>

        <h1 style={styles.title}>Site Under Maintenance</h1>

        <p style={styles.text}>
          We are currently performing scheduled maintenance.
          Please check back later.
        </p>
        <a href="/">
                <button style={styles.button}>
          Go Back
        </button>
        </a>

      </div>
    </div>
  );
}

export default Maintanance;

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f7f7f7",
  },

  card: {
    background: "#fff",
    padding: "50px 60px",
    borderRadius: "16px",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    maxWidth: "450px",
  },

  icon: {
    fontSize: "60px",
    marginBottom: "15px",
  },

  title: {
    marginBottom: "10px",
    color: "#333",
  },

  text: {
    color: "#666",
    marginBottom: "25px",
  },

  button: {
    padding: "10px 25px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#9e0b22",
    color: "white",
    cursor: "pointer",
    fontSize: "14px",
  },
};